



































































































































































































































import Vue from 'vue';
import * as _ from 'lodash';
import draggable from 'vuedraggable';
import ArrowUpDownBoldOutlineIcon from 'vue-material-design-icons/ArrowUpDownBoldOutline.vue';
import pxButton from '@/dex-shared/components/px-button.vue';
import pxCard from '@/dex-shared/components/px-card.vue';
import pxModal from '@/dex-shared/components/px-modal.vue';
import Icon from '@/dex-shared/components/Icon.vue';
import 'vue-datetime/dist/vue-datetime.css';
import { fileUploadURL } from '@/dex-shared/settings/endpoints';
import {
  BoardModel,
  TeacherModel,
  BoardsTeacherModel,
} from '@descomplica/dex-models';
import MaterialModel from '@/dex-shared/models/MaterialModel';

interface Data {
  creating: boolean;
  pushingBoard: boolean;
  createTeacher: boolean;
  selectedTeacherId: number | null;
  newTeacherName: string;
  newAvatarFile: Blob | null;
}

export default Vue.extend({
  components: {
    pxButton,
    pxCard,
    pxModal,
    Icon,
    draggable,
    ArrowUpDownBoldOutlineIcon,
  },

  data(): Data {
    return {
      creating: true,
      pushingBoard: false,
      createTeacher: false,
      selectedTeacherId: null,
      newTeacherName: null,
      newAvatarFile: null,
    };
  },

  computed: {
    board(): BoardModel {
      return this.$store.getters.currentBoard;
    },
    boardTeachers(): BoardsTeacherModel[] {
      if (!this.board.boardsTeachersByBoardId) return;
      return this.board.boardsTeachersByBoardId.nodes;
    },
    disciplines(): any[] {
      if (this.board && this.board.classrooms) {
        const descomplicaCourseSlugs = this.board.classrooms.map(
          classroom => classroom.descomplicaCourseSlug,
        );
        const disciplines = [...new Set(descomplicaCourseSlugs)];
        const allDisciplines: any = disciplines.reduce(
          (acc: any, discipline: any): Array<any> => {
            const _disciplines =
              this.$store.state.descomplica.disciplines[discipline] || [];
            return [...acc, ..._disciplines];
          },
          [],
        );
        return _.orderBy(allDisciplines, ['name'], ['asc']);
      }
      return [];
    },
    teachers(): TeacherModel[] {
      return this.$store.state.teachers.teachers;
    },
    mutableMaterials: {
      get(): MaterialModel[] {
        return this.board.materials;
      },
      set(sortedItems: Array<{ id: number; position: number }>): void {
        sortedItems.map(
          (material: { id: number; position: number }, index: number) => {
            material.position = index;
          },
        );
        sortedItems.sort((A, B) => A.position - B.position);
        this.$store.commit('UPDATE_MATERIAL_REORDERED', sortedItems);
      },
    },
    checkDuplicate(): boolean {
      if (!this.board.teachers) return this.selectedTeacherId === null;
      const teacherIds = this.board.teachers.map(teacher => teacher.id);
      return (
        this.selectedTeacherId === null ||
        teacherIds.includes(this.selectedTeacherId)
      );
    },
    checkNewTeacherSave(): boolean {
      return this.newTeacherName == null || this.newAvatarFile == null;
    },
  },

  async created() {
    await this.$store.dispatch('PULL_TEACHERS');
    this.creating = this.$route.name === 'board_create';
    if (this.creating) {
      this.$store.commit('SET_EMPTY_BOARD');
    } else {
      await this.pullBoard();
      //TODO no board found
    }
    const classrooms = this.board.classrooms || [];
    classrooms.map(async classroom => {
      if (classroom.descomplicaCourseSlug)
        await this.$store.dispatch(
          'PULL_DISCIPLINES',
          classroom.descomplicaCourseSlug,
        );
    });
  },

  methods: {
    async pullBoard(): Promise<void> {
      let boardId = parseInt(this.$route.params.boardId);
      await this.$store.dispatch('PULL_BOARD', boardId);
    },
    toggleCreateTeacherModal(): void {
      this.createTeacher = !this.createTeacher;
    },
    async createBoardsTeacher(): Promise<void> {
      if (this.checkDuplicate) return;
      await this.$store.dispatch('ADD_BOARDS_TEACHER', {
        teacherId: this.selectedTeacherId,
        boardId: this.board.id,
      });
      await this.pullBoard();
      this.selectedTeacherId = null;
    },
    async removeBoardsTeacher(boardsTeacherId: number): Promise<void> {
      await this.$store.dispatch('REMOVE_BOARDS_TEACHER', boardsTeacherId);
      await this.pullBoard();
    },
    async pushBoard(): Promise<void> {
      //TODO valid board

      if (this.pushingBoard) return;

      this.pushingBoard = true;
      try {
        if (this.board.materials) {
          await this.$store.dispatch(
            'UPDATE_MATERIAL_POSITION',
            this.board.materials,
          );
        }

        await this.$store.dispatch('PUSH_BOARD', this.board);
      } catch (err) {
        this.pushingBoard = false;
        return alert(
          `Algo deu errado! Envie essa mensagem aos desenvolvedores: ${err}`,
        );
      }

      this.pushingBoard = false;
      //TODO error inputing board
      if (this.board.id) {
        this.$router.push(`/mural/${this.board.id}`);
      }
    },
    goHome(): void {
      this.$router.push('/');
    },
    onAvatarChanged(event: any): void {
      this.newAvatarFile = event.target.files[0];
    },
    async saveNewTeacher(newTeacherAvatarUrl: string): Promise<void> {
      await this.$store.dispatch('PUSH_TEACHER', {
        name: this.newTeacherName,
        avatarUrl: newTeacherAvatarUrl,
      });
      this.newTeacherName = null;
      this.newAvatarFile = null;
      this.toggleCreateTeacherModal();
    },
    async onUpload(): Promise<void> {
      if (this.checkNewTeacherSave) return;
      const reader = new FileReader();

      reader.onloadend = async () => {
        let response = await fetch(`${fileUploadURL}`, {
          method: 'POST',
          mode: 'cors',
          body: JSON.stringify({ image: reader.result }),
        });
        let secondResponse = await response.json();
        await this.saveNewTeacher(secondResponse.location);
      };

      reader.readAsDataURL(this.newAvatarFile);
    },
  },
});
